import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import LazyLoader from "../../lib/lazyLoader";
import SocialMedia from "./SocalMedia";
import Support from "./Support";
import SecondaryFooter from "./SecondaryFooter";
import Company from "./Company";
import OurPartners from "./OurPartners";
import { RECRUITER_ANDROID_APP } from "../../services/constants";

const styles = theme => ({
  root: {
    backgroundColor: "#FAFAFA",
    width: "100%"
  },
  footerContainer: {
    padding: "5% 10%"
  },
  loginRoot: {
    zIndex: 1, //will check
    position: "fixed",
    bottom: 0,
    height: "50px",
    ["@media (max-width:576px)"]: { height: "70px" }
  },
  heading: {
    ...theme.typography.defaultFont,
    color: "#000000",
    fontWeight: 700,
    margin: "15px 0",
    lineHeight: "17px"
  },
  subHeading: {
    ...theme.typography.defaultFont,
    color: "#99A7A8",
    textDecoration: "none",
    marginBottom: "5px",
    display: "flex",
    cursor: "pointer",
    marginBottom: "7px"
  },
  footerItem: { marginBottom: "20px", width: "100%" },
  rights: {
    ...theme.typography.defaultFont,
    padding: "10px",
    width: "100%",
    height: "32px",
    padding: "10px 10%",
    fontSize: "10px",
    textAlign: "center",
    ["@media (max-width:576px)"]: {
      fontWeight: "700"
    },
    lineHeight: "12px",
    backgroundColor: "#EBEAEB"
  },
  writeReview: { color: "#2A89F6" },
  helpText: { ...theme.typography.tertiaryFont },
  phone: {
    ...theme.typography.defaultFont,
    color: theme.palette.primary.main,
    fontSize: "13px"
  },
  helpContainer: { textAlign: "center" },
  loginContainer: { padding: "15px" },

  googlePlay: {
    width: "131px",
    marginTop: "20px",
    ["@media (max-width:576px)"]: {
      width: "115px",
      marginTop: "0px"
    }
  },
  mobile: {
    ["@media (min-width:576px)"]: {
      display: "none"
    }
  },
  desktop: {
    ["@media (max-width:576px)"]: {
      display: "none"
    }
  },
  icons: {
    margin: "40px 0",
    ["@media (min-width:576px)"]: {
      margin: "15px 0"
    }
  }
});

class Footer extends Component {
  render() {
    const { classes, isLogin, deviceType } = this.props;
    const curYear = new Date().getFullYear() ? new Date().getFullYear() : 2021;
    const isSecondaryFooter = isLogin;
    const isMobile = deviceType === "mobile";
    return (
      <footer
        className={
          isSecondaryFooter
            ? classnames(classes.root, classes.loginRoot)
            : classes.root
        }
      >
        {isSecondaryFooter ? (
          <SecondaryFooter curYear={curYear} isMobile={isMobile} />
        ) : (
          <>
            <div className={classes.footerContainer}>
              <Grid
                container
                className={classes.mobile}
                justify="space-between"
                item
              >
                <Grid item xs={6} className={classes.icons}>
                  <img
                    data-src="/hire/recruiter-logo.svg"
                    alt="jobhai.com"
                    width="100"
                  />
                  <br />
                </Grid>
                <Grid item xs={6} className={classes.icons}>
                  <a href={RECRUITER_ANDROID_APP} target="_blank">
                    <img
                      data-src="/hire/google_play_logo.png"
                      alt="my image"
                      className={classes.googlePlay}
                      width="115px"
                      height="34px"
                    />
                  </a>
                </Grid>
                <Grid item xs={6}>
                  <Company classes={classes} />
                </Grid>
                <Grid item xs={6}>
                  <Support classes={classes} />
                </Grid>

                <Grid item xs={6}>
                  <SocialMedia classes={classes} />
                </Grid>
              </Grid>
              <Grid container className={classes.desktop}>
                <Grid item xs={3}>
                  <Grid item className={classes.icons}>
                    <img data-src="/hire/recruiter-logo.svg" alt="jobhai.com" />
                    <br />
                  </Grid>
                  <Grid item className={classes.icons}>
                    <a href={RECRUITER_ANDROID_APP} target="_blank">
                      <img
                        data-src="/hire/google_play_logo.png"
                        alt="my image"
                        className={classes.googlePlay}
                        width="131px"
                        height="38px"
                      />
                    </a>
                  </Grid>
                </Grid>

                <Grid item container xs={9} justify="space-between">
                  <Grid item container>
                    <Grid item xs>
                      <Company classes={classes} />
                    </Grid>
                    <Grid item xs>
                      <Support classes={classes} />
                    </Grid>
                    <Grid item xs>
                      <SocialMedia classes={classes} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <OurPartners />
            {/* <Divider /> */}
            <Grid item className={classes.rights}>
              All rights reserved © {curYear} Info Edge (India) Ltd.
            </Grid>
          </>
        )}
      </footer>
    );
  }
}

const mapStateToProps = state => ({
  candidateState: state.candidateListingReducer,
  deviceType: state.commonReducer.deviceType
});

export default connect(mapStateToProps)(withStyles(styles)(LazyLoader(Footer)));
